import { HomeView } from "../../components";

export const Home = HomeView;
